define('modules/settings/settings.module',["client"], function(Prospector){
    Prospector.module("SettingsApp", function(SettingsApp, Prospector, Backbone, Marionette, $, _){
        SettingsApp.startWithParent = false;
        SettingsApp.isNotLockedOut = true;
        SettingsApp.onStart = function(){
            window.utils.rawOutput("starting SettingsApp");
        };
        SettingsApp.onStop = function(){
            window.utils.rawOutput("stopping SettingsApp");
        };
        SettingsApp.hasSalesForce = function(){
            return window.entitlements.get('settings').allowSalesForce;
        };
        SettingsApp.hasSkrapp = function(){
            return window.entitlements.get('settings').allowSkrapp;
        };
        SettingsApp.hasBoardExEnterprise = function(){
            return window.entitlements.get('settings').allowBoardExEnterprise;
        };

        SettingsApp.hasLinkedIn = function(){
            return window.entitlements.get('settings').allowLinkedIn;
        }

        SettingsApp.isGlueConnected = false;

        SettingsApp.Glue = {
            connected: false,
            NetSuite:{
                appName: "NetSuite 42",
                isResolvingAccount: function(){
                    var returnBool = false;
                    try{
                        this.netsuiteAccount = window.utils.readLocalStorageObject('accountObject');
                        if(this.netsuiteAccount != null) {
                            returnBool = true;
                        }
                    } catch(ex){

                    }
                    return returnBool;
                }
            }
        }

        SettingsApp.isGlueNetSuiteConnected = function(){
            var returnBool = false;
            try{
                var servers = window.T42.glue.agm.servers();
                _.each(servers, function(server){
                    if(server.application == SettingsApp.Glue.NetSuite.appName){
                        returnBool = true;
                    }
                }, this);

            } catch(ex){

            }
            return returnBool;
        };

        SettingsApp.hasRoleMonitoring = function(){
            var returnVal = true;
            if(window.entitlements.get('settings') != undefined &&
                window.entitlements.get('settings').allowRoleAlerts != undefined &&
                !window.entitlements.get('settings').allowRoleAlerts){
                returnVal = false;
            }
            if(
                window.entitlements.get('settings') != undefined &&
                window.entitlements.get('settings').roleMonitoringLimit != undefined &&
                window.entitlements.get('settings').roleMonitoringLimit == 0){
                returnVal = false;
            }
            return returnVal;
        }

        SettingsApp.hasFollowing = function(){
            var returnVal = true;
            if(!window.entitlements.get('settings').allowFollowing){
                returnVal = false;
            }
            if(window.entitlements.get('settings').followingLimit == 0){
                returnVal = false;
            }
            return returnVal;
        }

        SettingsApp.hasTick42Glue = function(){
            return window.entitlements.get('settings').allowTick42Glue;
        }
        SettingsApp.hasCertainPercentage = function (){
            return 95; //returns percentage of quota
        }

        SettingsApp.GlueStorage = {
            account: {},
            contact: {}
        };

    });

    /*Prospector.module("Routers.SettingsApp", function(SettingsAppRouter, Prospector, Backbone, Marionette, $, _){
        SettingsAppRouter.Router = Marionette.AppRouter.extend({
            appRoutes: {
                "accountInfo"                 : "accountInfo",
                "plans"                       : "plans",
                "teamMembers"                 : "teamMembers",
                "generalSettings"             : "generalSettings",
                "subscriptionLimits"          : "contractQuotas",
                "skrappLimits"                : "skrappSettings", //added
                "integrations/salesForce"     : "salesForceIntegration",
                "integrations/boardEx"        : "boardExIntegration",
                "salesforce/session(options)" : "salesForceSession",
                "layoutSettings"              : "loadLayoutSettings"
            }
        });
        var API = {
            showAcceptedTerms: function(options) {
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.showAcceptedTerms(options);
                });
            },
            mustResetPassword: function(options) {
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.mustResetPassword(options);
                });
            },
            addCreditCard:function(options){
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.addCreditCard(options);
                });},
            upgradePlan:function(options){
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.upgradePlan(options);
                });},
            changeAutoRenew:function(options){
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.changeAutoRenew(options);
                });},
            accountInfo: function() {
                var func = $.proxy(function () {
                    require(["modules/settings/accountInfo/account.info.controller"], function (AccountInfoController) {
                        window.utils.raygunTrack('accountInfo');
                        AccountInfoController.loadAccountInfo();
                    });
                }, this);
                Prospector.trigger("authAcc", func);
            },
            teamMembers: function() {
                    var func = $.proxy(function () {
                        if(window.user.get('isAdmin')){
                            require(["modules/settings/teamMembers/team.members.controller"], function (TeamMembersController) {
                                window.utils.raygunTrack('teamMembers');
                                TeamMembersController.loadTeamMembers();
                            });
                        } else {
                            Prospector.navigate('dashboard', true);
                        }
                    }, this);
                    Prospector.trigger("authAcc", func);
            },
            plans: function() {
                var func = $.proxy(function () {
                    require(["modules/settings/accountInfo/account.info.controller"], function (AccountInfoController) {
                        window.utils.raygunTrack('plans');
                        AccountInfoController.loadChangePlan();
                    });
                }, this);
                Prospector.trigger("authAcc", func);
            },
            removeTeamMemberView: function(options) {
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.removeTeamMemberView(options);
                });
            },
            generalSettings:function(){
                var func = $.proxy(function () {
                    require(["modules/settings/generalSettings/general.settings.controller"], function (GeneralSettingsController) {
                        window.utils.raygunTrack('generalSettings');
                        GeneralSettingsController.loadGeneralSettings();
                    });
                }, this);
                Prospector.trigger("authAcc", func);
            },
            loadLayoutSettings:function(options){
                var func = $.proxy(function () {
                    require(["modules/settings/layout/layout.controller"], function (LayoutController) {
                        window.utils.raygunTrack('layoutSettings');
                        LayoutController.loadLayoutSettings();
                    });
                }, this);
                Prospector.trigger("authAcc", func);
            },
            contractQuotas:function(){
                var func = $.proxy(function () {
                    require(["modules/settings/quotas/contract.quotas.controller"], function (ContractQuotasController) {
                        window.utils.raygunTrack('subscriptionLimits');
                        ContractQuotasController.loadContractQuotas();
                    });
                }, this);
                Prospector.trigger("authAcc", func);
            },
            //added skrappSettings
            skrappSettings:function(){
                var func = $.proxy(function () {
                    require(["modules/settings/skrapp/skrapp.settings.controller"], function (SkrappSettingsController) {
                        window.utils.raygunTrack('subscriptionLimits');
                        SkrappSettingsController.loadContractQuotas();
                    });
                }, this);
                Prospector.trigger("authAcc", func);
            },
            lockToAccountInfo:function(){
                if(Prospector.SettingsApp.isNotLockedOut){
                    Prospector.SettingsApp.isNotLockedOut = false;
                    var passedFunc = function(){
                        Prospector.trigger("accountInfo");
                    }
                    Prospector.trigger("showMinimal", {
                        passedFunc: passedFunc
                    });
                }
            },
            salesForceIntegration:function(){
                var func = $.proxy(function () {
                    if(Prospector.SettingsApp.hasSalesForce()){
                        window.utils.raygunTrack('integrations/salesforce');
                        require(["modules/settings/salesForce/sales.force.controller"], function (controller) {
                            controller.loadSalesForceIntegration();
                        });
                    } else {
                        Prospector.navigate("dashboard", true);
                    }
                }, this);
                Prospector.trigger("authAcc", func);
            },
            salesForceSession:function(options){
                if(window.location.href.indexOf('#') > window.location.href.indexOf('?')){
                    var href = window.location.href.split('#')[0];
                    var code = window.utils.getQueryStringParameter(href, 'code');
                    window.location.href = window.location.origin + window.location.pathname + '#salesforce/session?code=' + $.trim(code);
                } else {
                    var func = $.proxy(function () {
                        if (Prospector.SettingsApp.hasSalesForce()) {
                            require(["modules/settings/salesForce/sales.force.controller"], function (SalesForceController) {
                                window.utils.raygunTrack('salesforce/session');
                                SalesForceController.loadSalesForceSession(options);
                            });
                        } else {
                            Prospector.navigate("dashboard", true);
                        }
                    }, this);
                    Prospector.trigger("authAcc", func);
                }
            },
            glueIntegrationPage:function(){
                //deprecated.
                var func = $.proxy(function () {
                    if(Prospector.SettingsApp.hasTick42Glue()){
                        require(["modules/settings/glue/glue.controller"], function (controller) {
                            controller.loadGlueIntegration();
                        });
                    } else {
                        Prospector.navigate("dashboard", true);
                    }
                }, this);
                Prospector.trigger("authAcc", func);
            },
            glueIntegration: function() {
                if(Prospector.SettingsApp.hasTick42Glue()) {
                    require(["modules/settings/glue/glue.controller"], function (controller) {
                        controller.buildModel();
                    });
                }
                else {
                  //  alert("You dont have Tick 42 Glue!!");
                    Prospector.SettingsApp.isGlueConnected.boolean = false;
                }
            },
            boardExIntegration:function(options){
                //deprecated.
                var func = $.proxy(function () {
                    if(Prospector.SettingsApp.hasBoardExEnterprise()) {
                        require(["modules/settings/boardex/boardex.controller"], function (BoardExController) {
                            window.utils.raygunTrack('integration/boardex');
                            BoardExController.loadBoardExIntegration(options);
                        });
                    } else {
                        Prospector.navigate("dashboard", true);
                    }
                }, this);
                Prospector.trigger("authAcc", func);
            },
            showListLimitModal:function(options){
                require(["modules/settings/modals/modals.controller"], function (ModalController) {
                    ModalController.showListLimitModal(options);
                });
            }
        };

        Prospector.on("showAcceptedTerms", function(options){
            API.showAcceptedTerms(options);
        });

        Prospector.on("mustResetPassword", function(options){
            API.mustResetPassword(options);
        });

        Prospector.on("addCreditCard", function(options){
            API.addCreditCard(options);
        });

        Prospector.on("changeAutoRenew", function(options){
            API.changeAutoRenew(options);
        });

        Prospector.on("removeTeamMemberView", function(options){
            API.removeTeamMemberView(options);
        });

        Prospector.on("upgradePlan", function(options){
            API.upgradePlan(options);
        });

        Prospector.on("accountInfo", function(options){
            Prospector.navigate("accountInfo");
            API.accountInfo(options);
        });
        
        Prospector.on("lockToAccountInfo", function(options){
            API.lockToAccountInfo(options);
        });

        Prospector.on("showListLimitModal", function(options){
            API.showListLimitModal(options);
        });

        Prospector.on('loadLayout', function(options){
            Prospector.navigate('layoutSettings');
            API.loadLayoutSettings(options);
        });

        Prospector.on('glueAuthentication', function(options){
            API.glueIntegration(options);
        });
        Prospector.addInitializer(function(){
            new SettingsAppRouter.Router({
                controller: API
            });
        });
    });*/
    return Prospector.SettingsAppRouter;
});
